export interface Ticket {
  id_ticket: number;
  id: number;
  issue_id_jira: string | null;
  asunto: string;
  estado: EnumStateTicket;
  modulo: string;
  submodulo: string;
  descripcion: string;
  archivo: string | null;
  id_usuario: number;
  id_municipio: number;
  fecha_alta: string;
  fecha_modificacion: string | null;
  nombre_usuario?: string;
  nombre_municipio?: string;
  /** IdTipo (FK TipoIncidencia): 1 Interna, 2 Externa */
  IdTipo?: number | null;
  tipoTicket?: number | null;
  plataforma?: 'preview' | 'production' | null;
  nombre_tipo_incidencia?: string | null;
  nombre_tipo_ticket?: string | null;
  /** FK Usuarios.IdUsuario: usuario que cerró el ticket */
  id_user_cierre_ticket?: number | null;
  nombre_usuario_cierre?: string | null;
  totalRegistros?: number;
}

export interface ModelStateTicket {
  title: 'open' | 'under_review' | 'resolved_in_preview' | 'closed',
  option: EnumStateTicket
}

export enum EnumStateTicket {
  open = 'abierto',
  under_review = 'en revision',
  resolved_in_preview = 'resuelto en preview',
  closed = 'cerrado'
}

export interface ModelAllowedModules {
  name: EnumAllowedModules
}

export enum EnumAllowedModules {
  traffic = 'Trafico',
  management = 'Gestion',
  admin = 'Administrar',
  telemetry = 'Telemetría',
  zar = 'infracciones',
  weather = 'Clima',
  otros = 'otros'
}